import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ModalController, PopoverController } from '@ionic/angular';
import { ExtractDigitalAccountResponse, ExtractDigitalAccountService } from '@wlp/ui-bs-cashout';
import { UserInfoService } from '@wlp/ui-bs-login';
import { UserInfoProfile } from '@wlp/ui-bs-login/lib/dto/user-info-profile';
import * as moment from 'moment';
import { ModalCsvGenerateComponent } from 'src/app/views/themes/sentinel/modals/modal-csv-generate/modal-csv-generate.component';
import { ModalPdfGenerateComponent } from 'src/app/views/themes/sentinel/modals/modal-pdf-generate/modal-pdf-generate.component';
import { PopoverSaveOptionsComponent } from 'src/app/views/themes/sentinel/modals/popover-save-options/popover-save-options.component';

import { ExtractDataFilterPipe } from '../extract-data-filter.pipe';
import { ExtractUtil } from '../extract-util';
import { ExtractUtilInterface } from '../extract-util.interface';
import { Storage } from '@ionic/storage';

@Component({
  selector: 'ui-t-extract-digital-account',
  templateUrl: './extract-digital-account.page.html',
  styleUrls: ['./extract-digital-account.page.scss'],
  providers: [ExtractDataFilterPipe],
})
export class ExtractDigitalAccountPage extends ExtractUtil implements ExtractUtilInterface, OnInit {

  userProfile: UserInfoProfile;
  secundary: boolean

  constructor(
    public popoverController: PopoverController,
    public pipeFilter: ExtractDataFilterPipe,
    public detection: ChangeDetectorRef,
    public modalController: ModalController,
    private extractDigitalAccountService: ExtractDigitalAccountService,
    protected userInfoService: UserInfoService,
    private storage: Storage) {
    super(pipeFilter, detection, modalController);
  }

  ngOnInit(): void {
    this.loadUser();
  }

  ionViewWillEnter() {
    this.listStatment = [];
    this.getDigitalStatement();
    this.checkViewBalanceSecundaryUser();
  }

  async checkViewBalanceSecundaryUser(){
    await this.storage.get('permissions')
    .then(res => {
      console.log(res)
      this.secundary = res[0] === '*' ? false : true
    })
  }

  loadUser() {
    try {
      const userDetails = this.userInfoService.getInfoProfile();
      userDetails.then(user => {
        this.userProfile = user;
      });
    } catch (e) {
      console.log('Failed to load user details', e);
    }
  }

  public getDigitalStatement(initial?: Date) {
    if (initial === undefined) {
      initial = this.calInitialDate;
    }

    this.extractDigitalAccountService
      .getStatement(this.userProfile.uuidWhiteLabel, this.userProfile.uuidAccount, initial, this.calEndDate)
      .subscribe(
        res => {
          this.listStatment = res;
          // atualiza o front da tabela
          this.setArrayForShow(true);
          this.calcPagination();
        },
        err => console.error('Erro', err));
  }

  public valueDisplayCreditOrDebit(extractDigitalAccount: ExtractDigitalAccountResponse): number {
    return this.extractDigitalAccountService.valueDisplayCreditOrDebit(extractDigitalAccount);
  }

  showIsBalance(typeStatement: string): boolean {
    return this.extractDigitalAccountService.showIsBalance(typeStatement);
  }

  showIsCreditOrDebit(typeStatement: string): boolean {
    return this.extractDigitalAccountService.showIsCreditOrDebit(typeStatement);
  }

  isCredit(typeStatement: string): boolean {
    return this.extractDigitalAccountService.isCredit(typeStatement);
  }

  /**
 * apresentacao da data na tabela
 * @param date
 */
  public getHourDate(date: any): string {
    try {
      return `${moment(this.formattedDate(date)).format('HH:mm:ss')}`;
    } catch (err) {
      return '';
    }
  }

  public formattedDate(date) {
    if (date && typeof date === 'object' && date.constructor === Array) {
      if (date.length >= 6) {
        return new Date(date[0], (date[1] - 1), date[2], date[3], date[4], date[5]);
      } else if (date.length === 5) {
        return new Date(date[0], (date[1] - 1), date[2], date[3], date[4]);
      }
      return new Date(date[0], date[1], date[2]);
    }

    return date;
  }

  public async openPDF() {
    const modal = await this.modalController.create({
      component: ModalPdfGenerateComponent,
      cssClass: 'modal-pdf-generate',
      componentProps: {
        listStatmentShow: this.listStatment,
        userProfile: this.userProfile
      },
    });
    return await modal.present();
  }

  public async openCSV() {
    const modal = await this.modalController.create({
      component: ModalCsvGenerateComponent,
      cssClass: 'modal-csv-generate',
      componentProps: {
        listStatmentShow: this.listStatment,
        userProfile: this.userProfile
      },
    });
    return await modal.present();
  }

  async presentPopover(ev: any) {
    const popover = await this.popoverController.create({
      component: PopoverSaveOptionsComponent,
      cssClass: 'popover-save-options',
      event: ev,
      translucent: true,
      showBackdrop: false,
      mode: 'md'
    });

    await popover.present();

    const { data } = await popover.onDidDismiss();
    data && await this.openModal(data);
  }

  async openModal(type: string) {
    const modal = {
      'pdf': () => this.openPDF(),
      'csv': () => this.openCSV()
    }
    return await modal[type]();
  }
}
